<template>
  <section class="faq-section">
    <div class="container">
      <div class="section-header">
        <h2>{{ $t('homePage.faq.title') }}</h2>
      </div>

      <div class="faq-container">
        <div v-for="(item, index) in faqData" :key="index" class="faq-item">
          <button
            class="faq-question"
            :class="{ active: expandedFaq === index }"
            @click="expandedFaq = expandedFaq === index ? null : index"
          >
            <span>{{ $t(`homePage.faq.items.${index}.question`) }}</span>
            <span class="faq-icon">+</span>
          </button>
          <transition name="faq-expand">
            <div v-if="expandedFaq === index" class="faq-answer">
              {{ $t(`homePage.faq.items.${index}.answer`) }}
            </div>
          </transition>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FaqSection',
  data() {
    return {
      expandedFaq: null,
      faqData: Array(6).fill(null)
    };
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/_variables.scss';

.faq-section {
  padding: 5rem 0;
  background: white;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;

  @media (max-width: 768px) {
    padding: 0 1.5rem;
  }
}

.section-header {
  text-align: center;
  margin-bottom: 4rem;

  h2 {
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 1rem;

    @media (max-width: 768px) {
      font-size: 2rem;
    }
  }
}

.faq-container {
  max-width: 800px;
  margin: 3rem auto 0;
}

.faq-item {
  border-bottom: 1px solid $border;
  padding: 1.5rem 0;

  &:first-child {
    border-top: 1px solid $border;
  }
}

.faq-question {
  width: 100%;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: $text-dark;
  transition: color 0.3s ease;
  text-align: left;

  &:hover {
    color: $brand-color;
  }

  &.active {
    color: $brand-color;
  }

  .faq-icon {
    font-size: 1.5rem;
    transition: transform 0.3s ease;
    flex-shrink: 0;
  }

  &.active .faq-icon {
    transform: rotate(45deg);
  }
}

.faq-answer {
  padding: 1rem 0;
  color: $text-light;
  line-height: 1.7;
  font-size: 0.95rem;
}

.faq-expand-enter-active,
.faq-expand-leave-active {
  transition: all 0.3s ease;
}

.faq-expand-enter-from,
.faq-expand-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
